/**
 * Action creator for sending a resource invitation to a patient.
 *
 * Returns a react-fetching-library request descriptor — used with
 * useMutation in the feature that owns the modal form. Pure function,
 * no React or store dependency.
 *
 * Endpoint: PUT /accounts/:accountUuid/patients/:patientUuid/resources
 */
export const createResourceInvitationAction = ({ accountUuid, patientUuid, body }) => ({
  method: 'PUT',
  endpoint: `/accounts/${accountUuid}/patients/${patientUuid}/resources`,
  body,
});
